module.exports = __webpack_public_path__ + "img/login-v2.3f291653.svg";